import { getApplicationId, getIsSalesForce } from '@fnol/library/src/lib';
import { translations } from './consts';
import { ThirdMessage } from '../components/IntroMessages/ThirdMessage';
import { FirstMessage } from '../components/IntroMessages/FirstMessage';
import { SecondMessage } from '../components/IntroMessages/SecondMessage';

const stepsComposer = () => [
    {
        path: '/stepOne',
        screen: getIsSalesForce(getApplicationId()) ? ThirdMessage : FirstMessage,
        step: 0,
        label: getIsSalesForce(getApplicationId())
            ? translations.stepLabel.INTRO_CONFIRMATION
            : translations.stepLabel.INTRO_START,
    },
    {
        path: '/stepTwo',
        screen: SecondMessage,
        step: 1,
        label: translations.stepLabel.INTRO_DOCUMENTATION,
    },
    {
        path: '/stepThree',
        screen: ThirdMessage,
        step: 2,
        label: translations.stepLabel.INTRO_CONFIRMATION,
    },
];

export default stepsComposer;
